import { render } from "./VvSelect.vue?vue&type=template&id=495b74d4"
import script from "./VvSelect.vue?vue&type=script&lang=js"
export * from "./VvSelect.vue?vue&type=script&lang=js"

import "./VvSelect.vue?vue&type=style&index=0&id=495b74d4&lang=css"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__